import WorkCarousel from '../../components/WorkCarousel/WorkCarousel';

const defaultImages = [
  { id: 1, src: `${process.env.PUBLIC_URL}/images/image1.png`, alt: 'Work 1' },
  { id: 2, src: `${process.env.PUBLIC_URL}/images/image2.png`, alt: 'Work 2' },
  { id: 3, src: `${process.env.PUBLIC_URL}/images/image3.png`, alt: 'Work 3' },
  { id: 4, src: `${process.env.PUBLIC_URL}/images/image4.png`, alt: 'Work 4' },
  { id: 5, src: `${process.env.PUBLIC_URL}/images/image5.png`, alt: 'Work 5' },
  { id: 6, src: `${process.env.PUBLIC_URL}/images/image6.png`, alt: 'Work 6' },
  { id: 7, src: `${process.env.PUBLIC_URL}/images/image7.png`, alt: 'Work 7' },
  { id: 8, src: `${process.env.PUBLIC_URL}/images/image8.png`, alt: 'Work 8' },
  { id: 9, src: `${process.env.PUBLIC_URL}/images/image9.png`, alt: 'Work 9' },
  { id: 10, src: `${process.env.PUBLIC_URL}/images/image10.png`, alt: 'Work 10' },
  { id: 11, src: `${process.env.PUBLIC_URL}/images/image11.png`, alt: 'Work 11' },
  { id: 12, src: `${process.env.PUBLIC_URL}/images/image12.png`, alt: 'Work 12' },
];

const Portfolio = ({ images }) => {
  const galleryImages = images && images.length ? images : defaultImages;
  return <WorkCarousel images={galleryImages} />;
};

export default Portfolio;
